import { render } from "./application_journal.html?vue&type=template&id=2e37e408&external"
import script from "./application_journal.js?vue&type=script&lang=js&external"
export * from "./application_journal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__